<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Fee',
  }
</script>

<style scoped>
</style>